import React from 'react';
import type { CFMap, MapLocation } from '@types';
import addComponent from '@utils/addComponent';
import { Collapse } from '@components/Collapse';
import ImageContainer from '@components/ImageContainer';
import { Validator } from '@components/Validator';
import LocationMap from '@components/LocationMap';
import Tip from '@components/Tip';
import Button from '@components/Button';
import MapModal from '@components/MapModal';
import { useCustomFeature } from '../CustomFeatureContext';

const hasLocation = (val: MapLocation): boolean => !!val.lng && !!val.lng;

function CMapSetting() {
  const { data, setData } = useCustomFeature<CFMap>();
  const setLocation = () => {
    addComponent((remove) => (
      <MapModal
        onRequestClose={remove}
        defaultLocation={data.location}
        onConfirm={(location) =>
          setData((draft) => {
            draft.location = location;
          })
        }
      />
    ));
  };
  return (
    <Collapse title="导航设置">
      <Validator
        value={data.location}
        validFn={(value) => hasLocation(value)}
        warningMessage="请设置地图导航"
      >
        {({ value, warning }) => (
          <ImageContainer
            className="h-115"
            placeholder="还未设置地图导航"
            warning={warning}
            onDeleteClick={() =>
              setData((draft) => {
                draft.location = {};
              })
            }
          >
            {hasLocation(value) && (
              <LocationMap location={value} className="h-full w-full" />
            )}
          </ImageContainer>
        )}
      </Validator>
      <div className="mt-10 flex items-center justify-between">
        <Tip>技术采用高德地图</Tip>
        <Button size="sm" onClick={setLocation}>
          设置地图导航
        </Button>
      </div>
    </Collapse>
  );
}

export default CMapSetting;
